import { Commission, UnitPricing } from "@covertree/new-business-graphql";

export const desiredDiscounts = [
  "Age of Home Discount",
  "Automatic Sprinkler Discount",
  "Mature Discount",
  "Community Discount",
  "Roof Condition Discount",
  "New Roof Discount",
  "Community Policy Discount",
  "Private Fire Company Tax Credit Discount",
  "Wrought Iron Bar Discount",
  "Burglar Alarm Discount",
  "Affinity/Association Discount",
  "Auto/Home Discount",
  "Claims Free Discount",
  "Multi Policy Discount",
  "Multi-Unit Discount",
  "Paid in Full Discount",
  "Paperless Discount",
  "Roof Payment Schedule Discount",
  "Storm Mitigation – Impact Resistant Glass Discount",
  "Storm Mitigation – Storm Shutters Discount",
  "Storm Mitigation – FORTIFIED Discount",
];

export function getDiscountsFromUnitPricing(unitPricing?: UnitPricing | null) {
  if (!unitPricing) {
    return {
      discounts: [],
      discountsTotal: 0,
    };
  }

  const finalDiscounts = unitPricing.commissions
    .filter((c): c is Commission => !!c && c.amount > 0)
    .filter((c) => desiredDiscounts.includes(c.recipient))
    .map((c) => ({
      name: c.recipient.replace("Discount", "").trim(),
      value: -c.amount,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return {
    discounts: finalDiscounts,
    discountsTotal: finalDiscounts.reduce<number>(
      (acc, curr) => acc - curr.value,
      0
    ),
  };
}
